import { reactive } from 'vue'
import actions from '@/store/integrations/actions'
import getters from '@/store/integrations/getters'
import state from '@/store/integrations/state'

export const integrationsModule = {
    state: reactive(state),
    actions,
    getters,
}
